const setSearch = (state, action) => action.search || state;

export default setSearch;
